/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('Error');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isError.js
// module id = 159
// module chunks = 0